const about = () => {
    return ( 
        <div className="about default-pad">
            <h2>About Us - Youga</h2>
            <p>
                Welcome to Youga, your local destination for invigorating yoga classes and wellness experiences. At Youga, we believe in promoting holistic well-being and providing a nurturing environment for individuals to enhance their physical, mental, and spiritual health through the practice of yoga.
            </p>
            <h2>Our Passion for Yoga</h2>
            <p>
                Founded by a team of dedicated yoga enthusiasts, Youga is driven by a deep passion for the transformative power of yoga. We understand that yoga is not just a physical exercise but a complete lifestyle that harmonizes the mind, body, and soul. Our mission is to share this passion and guide individuals on their journey to discovering the immense benefits of yoga.
            </p>
            <h2>Expert Instructors</h2>
            <p>
                At Youga, we are proud to have a team of highly trained and experienced yoga instructors who are committed to creating a safe and inclusive space for all levels of practitioners. Our instructors bring their unique styles and expertise to the classes, ensuring that you receive personalized attention and guidance in your yoga practice. They are dedicated to helping you unlock your true potential and achieve your wellness goals.
            </p>
            <h2>Variety of Classes</h2>
            <p>
                Whether you are a beginner taking your first steps on the yoga mat or an advanced practitioner seeking to deepen your practice, Youga offers a variety of classes to cater to your individual needs. From gentle and restorative yoga to dynamic and challenging vinyasa flows, we have classes that suit every preference and level of experience. Our class schedule is designed to accommodate busy lifestyles, ensuring that you can find a class that fits seamlessly into your routine.
            </p>
            <h2>Welcoming Community</h2>
            <p>
                At Youga, we believe that the power of yoga extends beyond the mat and into the connections we build with others. We foster a warm and inclusive community where individuals from all walks of life can come together to support and inspire each other. Our studio is a space free from judgment, where you can feel comfortable exploring your practice and embracing your unique journey.
            </p>
            <h2>Wellness Beyond Yoga</h2>
            <p>
                In addition to our yoga classes, we also offer workshops, retreats, and special events that delve deeper into the realms of wellness. These offerings encompass meditation sessions, mindfulness practices, and educational sessions on nutrition and self-care. We aim to provide a comprehensive approach to well-being, empowering you to cultivate balance, vitality, and inner peace in all aspects of your life.
            </p>
            












        </div>
     );
}
 
export default about;